export default "__VITE_PUBLIC_ASSET__c4b3bc59__"